import axios from 'axios';
import {backendHost} from '../../../../store/config';

export const getReplenishmentGeneralReport = (params) => {
    return axios.get(`${backendHost}/api/admin/replenishment/general`, {params});
};